import { Link } from 'react-router-dom';
import { games } from '../data/mods';
import './Home.css';

function Home() {
  return (
    <div className="home">
      <section className="hero">
        <h1>Kezza4K Mods</h1>
        <p>Browse and download my game mods</p>
      </section>

      <section className="games-section">
        <h2>Games</h2>
        <div className="games-grid">
          {games.map(game => (
            <Link to={`/game/${game.id}`} key={game.id} className="game-card">
              <div className="game-card-image">
                {game.thumbnail ? (
                  <img src={game.thumbnail} alt={game.name} />
                ) : (
                  <div className="game-card-placeholder">{game.name[0]}</div>
                )}
              </div>
              <div className="game-card-content">
                <h3>{game.name}</h3>
                <p>{game.description}</p>
              </div>
            </Link>
          ))}
        </div>
      </section>
    </div>
  );
}

export default Home;
